export const config = {
    // AUTH
    authority: process.env.SDS_AUTH_URL, //(string): The URL of the OIDC provider.
    login: process.env.SDS_AUTH_URL + "/login",
    authority_prod: process.env.SDS_AUTH_PROD_URL, //(string): The URL of the (DEV) OIDC provider.
    client_id: process.env.SDS_IDENTITY_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
    redirect_uri: process.env.SDS_REDIRECT_URL, //The URI of your client application to receive a response from the OIDC provider.
    silent_redirect_uri: process.env.SDS_SILENT_REDIRECT_URL, //(string): The URL for the page containing the code handling the silent renew.
    post_logout_redirect_uri: process.env.SDS_LOGOFF_REDIRECT_URL, // (string): The OIDC post-logout redirect URI.

    // VERSIONS
    version: process.env.SDS_VERSION,
    version_url: process.env.SDS_URLS_VERSION,

    // SDS
    sds_url: process.env.SDS_URL,
    sds_application: process.env.SDS_APP,
    environment: process.env.SDS_HOST_ENVIRONMENT,
    application: process.env.SDS_URLS_APPLICATION,
    authendpoint: process.env.SDS_URLS_AUTH_ENDPOINT,
    authUnauthorized: process.env.SDS_URLS_AUTH_UNAUTHORIZED,
    authredirect: process.env.SDS_URLS_AUTH_REDIRECT,
    language: process.env.SDS_URLS_LANGUAGE,
    logoutendpoint: process.env.SDS_URLS_LOGOUT_ENDPOINT,
    pluginsession: process.env.SDS_URLS_PLUGIN_SESSION,
    print: process.env.SDS_URLS_PRINT,
    progress: process.env.SDS_URLS_PROGRESS,
    project: process.env.SDS_URLS_PROJECT,
    queue: process.env.SDS_URLS_QUEUE,
    user: process.env.SDS_URLS_USER,

    // AHU
    ahu_application: process.env.SDS_APP_AHU,
    ahu: process.env.SDS_URLS_AHU,
    ahudata_url: process.env.SDS_URLS_AHU_DATA,
    ahudata_tenantid: process.env.SDS_URLS_AHU_DATA_TENANT_ID,
    ahujs: process.env.SDS_URLS_AHUJS,
    cadplugin: process.env.SDS_URLS_CAD_PLUGIN_API,
    calculations: process.env.SDS_URLS_CALCULATIONS,
    climate: process.env.SDS_URLS_CLIMATE,
    threedelements: process.env.SDS_URLS_THREE_D_ELEMENTS,
    mollier: process.env.SDS_URLS_MOLLIER,
    documentation: process.env.SDS_URLS_DOCUMENTATION,

    // ICD
    icd_application: process.env.SDS_APP_ICD,
    confwise: process.env.SDS_URLS_CONF_WISE,
    icdClient: process.env.SDS_URLS_ICD_CLIENT,
    icdServer: process.env.SDS_URLS_ICD_SERVER,
    icdMutateProjectUrl: process.env.SDS_URLS_ICD_MUTATE_PROJECT_URL,
    usetelerikdocumentgenerationdefaulticd:
        process.env.SDS_URLS_USETELERIKDOCUMENTGENERATIONDEFAULTICD,

    // MISC
    sessionId: null
};
